<template>
    <div>
        <el-dialog
            title="红包赠送记录导出"
            :visible.sync="dialogVisible"
            :close-on-click-modal='false'
            :close-on-press-escape='false'
            width="600px">
            <div class="formContent">
                <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="0px">
                    <el-form-item label="" prop="startTime">
                        <le-date-range
                            label="赠送日期"
                            :minDate.sync="form.startTime"
                            :maxDate.sync="form.endTime"
                            valueFormat="yyyy-MM-dd HH:mm:ss"
                            :defaultTime="['00:00:00','23:59:59']" />
                    </el-form-item>
                    <el-form-item label="" prop="companyId">
                        <le-company-under-select label="赠送商户" placeholder="请选择（可输入搜索）" v-model="form.companyId"></le-company-under-select>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSubmit">导出</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import util from '../../../../src/utils/util'
    import { mapActions } from 'vuex'
    export default {
        data() {
            var checkDate = (rule, value, callback) => {
                if(!this.form.startTime || !this.form.endTime){
                    callback(new Error('请选择赠送日期'))
                } else {
                    callback()
                }
            };
            return {
                dialogVisible: false,
                util: util,
                form: {
                    startTime: '',
                    endTime: '',
                    companyId: ''
                },
                rules: {
                    startTime: [{ validator: checkDate, trigger: 'change' }]
                }
            };
        },
        props:['userId','phone'],
        mounted () {
            this.initDefaultDate()
        },
        methods:{
            ...mapActions({
                setShowTips: 'exportFile/setShowTips'
            }),
            initDefaultDate () {
                this.form.startTime = this.$getDay.getTodayBeforeDays(90) + ' 00:00:00'
                this.form.endTime = this.$getDay.getToday() + ' 23:59:59'
            },
            handleSubmit () {
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        this.$Axios._post({
                            url: this.$Config.apiUrl.exportFileApi,
                            method: 'post',
                            params: {
                                code: 48,
                                fileName: '红包赠送记录',
                                startTime: this.form.startTime,
                                endTime: this.form.endTime,
                                params: {
                                    companyId: this.form.companyId,
                                    startTime: this.form.startTime,
                                    endTime: this.form.endTime,
                                }
                            }
                        }).then(res=>{
                            if (res.result.code == 0) {
                                this.$message.success('操作成功')
                                this.setShowTips()
                                this.dialogVisible = false
                            } else {
                                this.$message.error(res.result.message)
                            }
                        }).catch(err=>{

                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    /deep/ .el-dialog__wrapper{
        display: flex;
        justify-content: center !important;
        align-items: center !important;
    }
    /deep/ .el-dialog__body{
        padding: 10px 20px !important;
    }
    /deep/ .el-dialog{
        margin: 0 auto !important;
    }
    /deep/ .is-disabled{
        color: #333333 !important;
    }
    .formContent{
        max-height: 70vh;
        overflow: auto;
    }
    .tips{
        font-size: 12px;
        color: #909399;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        line-height: 22px;
    }
</style>